import { Markdown } from "../components/Markdown"
import { DandyTemplate } from "../templates/DandyTemplate"
import "./CeremonyPage.scss"

export function CeremonyPage() {
  return (
    <DandyTemplate title="Ceremony - Grand Tetons - Blake & Christie">
      <Markdown path="ceremony.md" />
    </DandyTemplate>
  )
}
